export default "__VITE_ASSET__DBG8HxyP__"